import {Injectable, signal} from '@angular/core';
import {
  SetWrapperElementSizeStateParams,
  WrapperElementSize,
  WrapperElementSizeMap
} from "../../types/table-types/wrapper-element-size.types";
import {nonFullHeightTables} from "../../models/non-full-height-tables";
import {defaultHeightParams} from "../../components/records-table-container/configs/record-table-container-config";

@Injectable({
  providedIn: 'root'
})
export class WrapperElementSizeStateService {
  private _wrapperElementSizeState = signal<WrapperElementSizeMap>({});
  public wrapperElementSizeState = this._wrapperElementSizeState.asReadonly();

  public setWrapperElementSizeState(setWrapperElementSizeStateParams: SetWrapperElementSizeStateParams): void {
    const { element, resourceParamsKey, currentTableZoom } = setWrapperElementSizeStateParams;
    const { width, height } = element.getBoundingClientRect();
    const isNonFullHeight = this.isNonFullHeightTables(resourceParamsKey);

    const wrapperElementSize: WrapperElementSize = {
      width: width / (currentTableZoom / 100) + 'px',
      height: isNonFullHeight ?
        defaultHeightParams.maxHeightSizeTable / (currentTableZoom / 100) + 'px' :
        height / (currentTableZoom / 100) + 'px'
    };

    this._wrapperElementSizeState.update(state => ({
      ...state,
      [resourceParamsKey]: wrapperElementSize
    }));
  }

  public getWrapperElementSize(resourceParamsKey: string): WrapperElementSize | null {
    return this.wrapperElementSizeState()[resourceParamsKey] || null;
  }

  public resetSpecificWrapperElementSize(resourceParamsKey: string): void {
    this._wrapperElementSizeState.update(state => {
      const newState = { ...state };
      delete newState[resourceParamsKey];
      return newState;
    });
  }

  public isNonFullHeightTables(resourceParamsKey: string): boolean {
    return nonFullHeightTables.some(modalType =>
      resourceParamsKey.includes(modalType)
    );
  }
}
